import api from 'api'
import { pathOr } from 'ramda'

export interface CompanyPosition {
  id: number
  positionTemplate: {
    id: number
    name: string
    relevantPositionTemplateWorkerCategories: Array<{
      name: string
    }>
  }
  isApproved: boolean
  bundling: string
  name: string
  about: string
  prescreened: boolean
  isTipEligible: boolean
  allowAutocushion: boolean
  needsCar: boolean
  needsLicense: boolean
  clockInCodeEnabled: boolean
  clockOutCodeEnabled: boolean
  requirements2: Array<{
    id: number
    name: string
    category: string
    credential: string
    verifiable: boolean
    isWorkerVisible: boolean
    verificationType: string
  }>
  mustHaveRequirements: Array<{
    id: number
  }>
  company: {
    id: number
    name: string
    isW2: boolean
    isW2Changeable: boolean
    chargeUpfront: boolean
    defaultPaymentSource: string
    isAbleToPostShifts: boolean
    companyShiftEndPaymentDelayHours: number
    minPayPolicies: Array<{
      startsAt: string
      minPayLength: number
    }>
    takePercentages: {
      rate1099: number
      w2Regular: number
      w2Overtime: number
      w2Double: number
      bonus: number
      tip: number
    }
    cancellationPolicies: Array<{
      startsAt: string
      policyWindows: Array<{
        cutoffTimeHours: number
        chargePercentage?: number | null
        chargeMinutes?: number | null
      }>
    }>
  }
}

export async function getCompanyPosition(positionId: number | null) {
  const response = await api.post(
    '/admin/graphql_dispatch/company_position_ef07ce96',
    { positionId }
  )
  return pathOr<CompanyPosition | null>(
    null,
    ['data', 'data', 'admin', 'positions', 0],
    response
  )
}
